$.ajaxSetup({
    data: {
        _token: csrfToken
    },
    beforeSend: function () {
        $(document).find('span.error-message-form').remove();
        $('.form-group').removeClass('has-error');
    },
    statusCode: {
        500: function () {
            showError("<span class='fa fa-remove fa-fw'></span> 500 <i>Internal Server Error</i>");
        },
        401: function () {
            showError("<span class='fa fa-remove fa-fw'></span> 401 <i>Unauthorized</i>");
        },
        403: function () {
            showError("<span class='fa fa-remove fa-fw'></span> 403 <i>Forbidden</i>");
        },
        404: function () {
            showError("<span class='fa fa-remove fa-fw'></span> 404 <i>Not Found</i>");
        },
        410: function () {
            showError("<span class='fa fa-remove fa-fw'></span> 410 <i>Gone</i>");
        },
        422: function (data) {
            var errors = data.responseJSON;
            showError(processErrors(errors));
            $.each(errors, function (key, value) {
                $('#' + key).parent().addClass('has-error has-feedback');
                $.each(value, function (key2, value2) {
                    $('#' + key).parent().append("<span class='help-block error-message-form'>" + value2 + "</span>");
                });
            });
        }
    }
});

$(document).ajaxComplete(function () {
    $("[id=waitingContainer]").each(function () {
        $(this).fadeOut(500);
    });
});

$(document).ajaxStart(function () {
    showWaiting("Please wait.");
});

function initCartScrollBar() {
    $(".scroll-pane").mCustomScrollbar({
        advanced: {
            updateOnContentResize: true

        },

        scrollButtons: {
            enable: false
        },

        mouseWheelPixels: "200",
        theme: "dark-2"

    });

    $(".smoothscroll").mCustomScrollbar({
        advanced: {
            updateOnContentResize: true

        },

        scrollButtons: {
            enable: false
        },

        mouseWheelPixels: "100",
        theme: "dark-2"

    });
}

